import React from 'react';
import { Container, Typography } from '@material-ui/core';

import useStyles from './styles';

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  const classes = useStyles();

  return (
    <div className={classes.box}>
      <div className={classes.root}>
        <div>
          <Typography className={classes.title} variant="h3">
            {title}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
